import { Link } from "@tanstack/react-router";

export const AddPaymentMethodNote = ({ locationId }: { locationId: number }) => (
  <>
    Add a payment method to resubscribe.{" "}
    <Link
      className="text-brand underline"
      to="/locations/$locationId/billing"
      params={{ locationId: String(locationId) }}
      target="_blank"
      preload={false}
    >
      Add payment method
    </Link>
  </>
);
